import { getApiRequest } from 'api';
import { ResponseEducationPlan } from 'types/educationalPlan';

export const getEducationalPlan = (id: number): Promise<ResponseEducationPlan> => {
    return getApiRequest(`/educational-plan/${id}/`);
};
